import { render } from "./new-rule-btn.vue?vue&type=template&id=3d1f7e5f"
import script from "./new-rule-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./new-rule-btn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/settings/pages/shipping-fees-and-locations/components/new-rule-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d1f7e5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d1f7e5f', __exports__)) {
    console.log('reload')
    api.reload('3d1f7e5f', __exports__)
  }
  
  module.hot.accept("./new-rule-btn.vue?vue&type=template&id=3d1f7e5f", () => {
    console.log('re-render')
    api.rerender('3d1f7e5f', render)
  })

}


export default __exports__